var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":_vm.bButtonType,"variant":_vm.bButtonVariant,"block":_vm.block,"size":"sm"},on:{"click":_vm.handleClick}},[_c('i',{class:_vm.iClass}),_c('span',{staticClass:"text-uppercase button-span"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }